import { combineReducers } from 'redux';
import { Actions, ActionTypes } from '../bookings/actions';

import { IAvailabilityV3BookingsResponse } from '../../api/bookings';
import { IEventV2 } from '../../data/entities/event';

const defaultbyPropertyId = {} as { [key: string]: IEventV2[] };

const receiveEvents = (current: IEventV2[], events: IEventV2[]) => {
	const ids = events.map((e) => e.id);
	const next = current.filter((e) => !ids.includes(e.id));
	return next.concat(events);
};

export const summariesByPropertyId = (state = defaultbyPropertyId, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.BOOKINGS_GET_BY_PROP_ID_RECEIVE:
			return { ...state, [action.payload.propertyId]: action.payload.bookings };
		case ActionTypes.BOOKINGV2_CANCEL_RECEIVE:
		case ActionTypes.BOOKINGV2_TRANSFER_RECEIVE:
			const next = receiveEvents(state[action.payload.propertyId] || [], action.payload.events);
			return { ...state, [action.payload.propertyId]: next };
		default:
			return state;
	}
};

type ByIdReducer = Record<string, IEventV2 | undefined>;

const defaultbyId: ByIdReducer = {};

export const byId = (state: ByIdReducer = defaultbyId, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.BOOKINGS_GET_BY_ID_RECEIVE:
			return { ...state, [action.payload.id]: action.payload };
		case ActionTypes.BOOKINGV2_UPDATE_RECEIVE:
			return { ...state, [action.payload.eventId]: action.payload.event };
		case ActionTypes.BOOKINGV2_CANCEL_RECEIVE:
		case ActionTypes.BOOKINGV2_TRANSFER_RECEIVE:
			return { ...state, [action.payload.eventId]: action.payload.events[0] };
		case ActionTypes.CANCELLATION_REQUEST_RESPONSE:
			const existing = state[action.payload.eventId] || {} as IEventV2;
			return {...state, [action.payload.eventId]: {...existing, cancellation_request: action.payload.cancellationRequest}};
		default:
			return state;
	}
};

type ByOwnerIdReducer = Record<string, IAvailabilityV3BookingsResponse | undefined>;

const defaultbyOwnerId: ByOwnerIdReducer = {};

export const byOwnerId = (state: ByOwnerIdReducer = defaultbyOwnerId, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.BOOKINGS_GET_BY_OWNER_ID_RECEIVE:
			return { ...state, [action.payload.ownerId]: action.payload.bookings };
		default:
			return state;
	}
};

export const firstBookingIdbyOwnerId = (state = defaultbyOwnerId, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.FIRST_BOOKING_GET_BY_OWNER_ID_RECEIVE:
			return { ...state, [action.payload.ownerId]: action.payload.firstBookingId };
		default:
			return state;
	}
};

export const statsByOwnerId = (state = {}, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.BOOKINGS_STATS_GET_BY_OWNER_ID_RECEIVE:
			return { ...state, [action.payload.ownerId]: action.payload.stats };
		default:
			return state;
	}
};

export const paymentLinkByEventId = (state = {}, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.BOOKING_PAYMENT_LINK_RECEIVE:
			return { ...state, [action.payload.eventId]: action.payload.paymentLink };
		default:
			return state;
	}
};

export interface IBookingsState {
	summariesByPropertyId: ReturnType<typeof summariesByPropertyId>;
	byId: ReturnType<typeof byId>;
	byOwnerId: ReturnType<typeof byOwnerId>;
	firstBookingIdbyOwnerId: ReturnType<typeof firstBookingIdbyOwnerId>;
	statsByOwnerId: ReturnType<typeof statsByOwnerId>;
	paymentLinkByEventId: ReturnType<typeof paymentLinkByEventId>;
}

export default combineReducers<IBookingsState>({
	summariesByPropertyId,
	byId,
	byOwnerId,
	firstBookingIdbyOwnerId,
	statsByOwnerId,
	paymentLinkByEventId
});
